import React, { useEffect, useState } from 'react'
import { fetchPublicCmsDataApi } from '../../services/common';

const AccountDeleteSetting = () => {
    const [accountSettingData, setAccountSetting] = useState("");

    useEffect(() => {
        const getAccountSettingData = async () => {
            try {
                const { data } = await fetchPublicCmsDataApi({ type: "DELETE" });
                const { data: accountSettingDesc, success, message } = data;
                if (success) {
                    // toastMessage(message, "success", "accountSettingDesc");
                    setAccountSetting(accountSettingDesc);
                }
            } catch (e) {
                console.log("Login:-", e.message);
            }
        };
        getAccountSettingData()
    }, [])
    return (
        <>
            <div className="Privacy_policy">
                <div className="container_privacy_policy">
                    <div className="privacy_policy_title">
                        <h2>Account Setting</h2>
                    </div>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: accountSettingData?.description,
                        }}
                    ></p>
                </div>
            </div>
        </>
    )
}

export default AccountDeleteSetting